import t from "../../locales/common.json";
import chevi from "../../img/chevi.svg";
import travel from "../../img/travel.svg";
import camera from "../../img/camara.svg";
import TravelSection from "./travel-section.marko";

<TravelSection
  title=t.cc.Travel.cuba.header
  image={ src: chevi, alt: t.cc.Travel.cuba.header }
>
  <p>${t.cc.Travel.cuba.text}</p>
</TravelSection>

<TravelSection
  title=t.cc.Travel.services.header
  image={ src: travel, alt: t.cc.Travel.services.header }
  reverse
>
  <u-list>
    <for|service| of=t.cc.Travel.services.list>
      <li>${service}</li>
    </for>
  </u-list>
</TravelSection>

<TravelSection
  title=t.cc.Travel.tourism.header
  image={ src: camera, alt: t.cc.Travel.tourism.header }
>
  <p>${t.cc.Travel.tourism.text}</p>
</TravelSection>
